import {
  ITaxFormResponse,
  TaxFormStatus
} from "@wingspanhq/payments/dist/interfaces";

export const selectorTaxFormIsPDFDownloadAvailableForPayer = (
  taxForm: ITaxFormResponse
): boolean => {
  const submissionId = taxForm.currentSubmissionId;
  const isPdfDownloadEnabled = taxForm.submissions?.find(
    s => s.taxFormSubmissionId === submissionId
  )?.isPdfDownloadEnabled;
  return (
    [
      TaxFormStatus.SubmittedToIrs,
      TaxFormStatus.AcceptedByIrs,
      TaxFormStatus.RejectedByIrs
    ].includes(taxForm.status) &&
    !!submissionId &&
    !!isPdfDownloadEnabled
  );
};
